module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-btn-audio-portuguesse.ffe839b8.png";